import { default as addConfiguration } from './add';
import { default as deleteExternalCpdConfiguration } from './deleteExternalCpd';
import { default as getConfiguration } from './get';
import { default as updateConfiguration } from './update';

export const configurations = [
  getConfiguration,
  addConfiguration,
  updateConfiguration,
  deleteExternalCpdConfiguration
]


// WEBPACK FOOTER //
// ./src/state/modules/external-cpd/configurations/index.js